<div class="title" [ngStyle]="{'background-image': 'url(' + img + ')'}" [ngClass]="smaller ? 'smaller' : ''">
  <div>{{title}}</div>
</div>
<div class="close-wrap">
  <img (click)="onCloseClick()" src="/assets/img/game/close-round.svg">
</div>

<div class="content">
  <ng-content></ng-content>
</div>